import './styles/nav-bar.css'
import { main } from "../../../assets/coach-assets/constants/colors"
import { fontType } from "../../../assets/extras"

//import { FaHistory, FaHome, FaEllipsisV } from "react-icons/fa";

const NavBar = ({ title }) => {
    return (
        <nav style={{
            backgroundColor: main,
            width: "100%",
            paddingTop: 20,
            paddingBottom: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 20,
            zIndex: 1000,
            flexDirection: "column"
        }}>
            <h1 style={{
                color: "white",
                fontFamily: fontType.title,
                letterSpacing: 3,
                textAlign: "center"
            }}>{title}</h1>
        </nav>
    )
}

/**
 * <div style={{
                marginTop: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                flexWrap: "wrap"
            }} className='cont-nav-bar-items'>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 8,
                    width: 150,
                    borderRight: "1px solid white",
                    gap: 5,
                    cursor: "pointer"
                }} className='nav-bar-item'>
                    <FaHistory size={20} color="white" />
                    <p style={{
                        fontFamily: fontType.text,
                        color: "white"
                    }}>HISTORIAL</p>
                </div>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 8,
                    width: 150,
                    borderRight: "1px solid white",
                    gap: 5,
                    cursor: "pointer"
                }} className='nav-bar-item'>
                    <FaHome size={20} color="white" />
                    <p style={{
                        fontFamily: fontType.text,
                        color: "white"
                    }}>INICIO</p>
                </div>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 8,
                    width: 150,
                    gap: 5,
                    cursor: "pointer"
                }} className='nav-bar-item'>
                    <FaEllipsisV size={20} color="white" />
                    <p style={{
                        fontFamily: fontType.text,
                        color: "white"
                    }}>SETTINGS</p>
                </div>
            </div>
 */

export default NavBar